<div class="freeform-dashboard">
    @if (categoryList()?.length !== 0) {
        <div class="dashboard-header">
            <tools-toggle
                [isChecked]="showTags()"
                [showCheckedLabel]="true"
                [labelPosition]="LabelPosition.BEFORE"
                (change)="onShowTagsChange($event.checked)"
            >
                Show Tags
            </tools-toggle>
        </div>
        <div class="tag-categories" [class.collapsed]="!showTags()">
            @if (categoryList() === null) {
                <div class="loading"></div>
            } @else {
                @for (category of categoryList()!; track category.key) {
                    <div class="category">
                        <p class="category-label">
                            {{ columnLabel()(category.key) }}
                        </p>
                        <div class="tags">
                            @for (
                                tagCount of category.tags;
                                track tagCount.tag
                            ) {
                                <tools-checkbox
                                    [isControlled]="true"
                                    [isChecked]="
                                        filters.isTagSelected(
                                            category.key,
                                            tagCount.tag
                                        )
                                    "
                                    [ariaLabel]="tagCount.tag"
                                    (change)="
                                        filters.toggleTag(
                                            category.key,
                                            tagCount.tag
                                        )
                                    "
                                >
                                    <span class="tag">
                                        {{ tagCount.tag }}
                                        ({{ tagCount.count }})
                                    </span>
                                </tools-checkbox>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    }
    <div class="dashboard-grid">
        <div class="dropdown-filters">
            <mat-form-field appearance="outline" class="dropdown-filter-by">
                <mat-label>Filter By</mat-label>
                <mat-select
                    multiple
                    panelWidth="fit-content"
                    [value]="filters.filterBy()"
                    (selectionChange)="filters.setFilterBy($event.value)"
                >
                    <mat-select-trigger>
                        @if (filters.filterBy().length > 1) {
                            ({{ filters.filterBy().length }})
                        } @else {
                            {{ filterByLabel(filters.filterBy()[0]) }}
                        }
                    </mat-select-trigger>
                    @for (option of filterByOptions; track option.value) {
                        <mat-option
                            [value]="option.value"
                            [disabled]="
                                option.value === 'isUsed' &&
                                !filters.isUsedFilterEnabled()
                            "
                        >
                            {{ option.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="dropdown-min-score">
                <mat-label>Score</mat-label>
                <mat-select
                    [value]="filters.minScore()"
                    (selectionChange)="filters.setMinScore($event.value)"
                >
                    @for (score of minScoreOptions; track score) {
                        <mat-option
                            [value]="score"
                            (onSelectionChange)="onMinScoreOptionSelect($event)"
                        >
                            {{ score }}+
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if (segmentOptions().length > 0) {
                <mat-form-field appearance="outline" class="dropdown-segment">
                    <mat-label>Segment</mat-label>
                    <mat-select
                        panelWidth="fit-content"
                        [value]="filters.segmentId()"
                        (selectionChange)="filters.setSegmentId($event.value)"
                    >
                        @for (segment of segmentOptions(); track segment.id) {
                            <mat-option
                                [value]="segment.id"
                                (onSelectionChange)="
                                    onSegmentOptionSelect($event)
                                "
                            >
                                {{ segmentFilterLabel(segment) }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
            <mat-form-field
                appearance="outline"
                class="dropdown-public-display"
            >
                <mat-label>Public Display</mat-label>
                <mat-select
                    panelWidth="fit-content"
                    [value]="filters.publicDisplay()"
                    (selectionChange)="filters.setPublicDisplay($event.value)"
                >
                    @for (option of publicDisplayOptions; track option.value) {
                        <mat-option [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                class="dropdown-customize-columns"
            >
                <mat-label>Columns</mat-label>
                <mat-select
                    multiple
                    panelWidth="27.5rem"
                    [value]="filters.selectedColumns()"
                    (selectionChange)="filters.setSelectedColumns($event.value)"
                >
                    <mat-select-trigger>
                        @if (filters.selectedColumns().length > 1) {
                            ({{ filters.selectedColumns().length }})
                        } @else {
                            {{ columnLabel()(filters.selectedColumns()[0]) }}
                        }
                    </mat-select-trigger>
                    @for (col of filters.availableColumns(); track col) {
                        <mat-option [value]="col">
                            {{ columnLabel()(col) }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @for (option of visibilityOptions; track option.value) {
                <tools-toggle
                    [isChecked]="filters.visibility().includes(option.value)"
                    [isControlled]="true"
                    (change)="filters.toggleVisibility(option.value)"
                >
                    {{ option.label }}
                </tools-toggle>
            }

            @if (filters.activeFilterCount() > 0) {
                <div class="active-filters">
                    <span class="caption-3">
                        {{ filters.activeFilterCount() }} active filter{{
                            filters.activeFilterCount() === 1 ? "" : "s"
                        }}
                    </span>
                    <span
                        class="icon-iec-info-solid"
                        #activeFiltersOrigin="cdkOverlayOrigin"
                        cdkOverlayOrigin
                        (mouseenter)="showActiveFiltersOverlay()"
                        (mouseleave)="hideActiveFiltersOverlay()"
                    ></span>
                    <ng-template
                        cdk-connected-overlay
                        [cdkConnectedOverlayOrigin]="activeFiltersOrigin"
                        [cdkConnectedOverlayOpen]="isActiveFiltersOverlayOpen"
                        [cdkConnectedOverlayPositions]="overlayPositions"
                        [cdkConnectedOverlayPush]="true"
                    >
                        <div class="active-filters-overlay-panel">
                            @for (
                                filterLabel of activeFilterLabels();
                                track $index + "-" + filterLabel.value
                            ) {
                                <p class="tooltip-1">
                                    @if (filterLabel.label) {
                                        {{ filterLabel.label }}:
                                        <strong>{{ filterLabel.value }}</strong>
                                    } @else {
                                        {{ filterLabel.value }}
                                    }
                                </p>
                            }
                        </div>
                    </ng-template>
                    <button
                        type="button"
                        class="clear-filters-btn"
                        (click)="filters.clearAll()"
                    >
                        Clear Filters
                    </button>
                </div>
            }
        </div>
        <div class="dashboard-filters">
            <tools-input
                prefix="search"
                placeholder="Search submissions"
                [formControl]="searchControl"
            />
            <div class="bulk-actions">
                @if (checkedIds().size > 0) {
                    <span class="caption-3">
                        {{ checkedIds().size }} selected
                    </span>
                    <button
                        type="button"
                        class="clear-selected-btn"
                        (click)="clearChecked()"
                    >
                        Clear Selections
                    </button>
                    <mat-form-field
                        appearance="outline"
                        class="dropdown-bulk-actions"
                    >
                        <mat-select
                            #bulkSelect
                            placeholder="Actions"
                            panelWidth="fit-content"
                            (selectionChange)="
                                onBulkAction($event.value, bulkSelect)
                            "
                        >
                            <mat-select-trigger>Actions</mat-select-trigger>
                            <mat-option value="make-public">
                                Allow Public Display
                            </mat-option>
                            <mat-option value="move">Move</mat-option>
                            <mat-option value="delete">Delete</mat-option>
                            <mat-option value="download-audio">
                                Download Audio
                            </mat-option>
                            <mat-option value="download-video">
                                Download Video
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                }
            </div>
        </div>
        <div><!-- Spacer --></div>
        <div class="submissions-table-container" #tableContainer>
            <table
                mat-table
                [dataSource]="dataSource"
                matSort
                (matSortChange)="dataSource.sortChange($event)"
                matSortDisableClear
                class="submissions-table"
                tabindex="-1"
                (click)="onTableClick($event)"
                (keydown.enter)="onTableClick($event)"
                (keydown.space)="onTableClick($event)"
            >
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <tools-checkbox
                            [isControlled]="true"
                            [isChecked]="isAllSelected()"
                            ariaLabel="Select all"
                            (change)="toggleAllChecks()"
                        />
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <tools-checkbox
                            [isControlled]="true"
                            [isChecked]="isRowSelected(row)"
                            ariaLabel="Select row"
                        />
                    </td>
                </ng-container>

                <ng-container matColumnDef="Score">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Score
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="score" [ngClass]="scoreTier(row.score)">
                            {{ row.score ?? "&mdash;" }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Queue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Queue
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{ row.priority ?? "&mdash;" }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <th mat-header-cell *matHeaderCellDef>
                        <span
                            #statusLegendOrigin="cdkOverlayOrigin"
                            cdkOverlayOrigin
                        >
                            Status
                            <span
                                class="key"
                                (mouseenter)="showStatusLegend()"
                                (mouseleave)="hideStatusLegend()"
                            >
                                Key
                            </span>
                        </span>
                        <ng-template
                            cdk-connected-overlay
                            [cdkConnectedOverlayOrigin]="statusLegendOrigin"
                            [cdkConnectedOverlayOpen]="isStatusLegendOpen"
                            [cdkConnectedOverlayPositions]="
                                statusLegendPositions
                            "
                            [cdkConnectedOverlayPush]="true"
                        >
                            <ul class="status-legend-overlay-panel">
                                @for (item of statusLegend; track item.icon) {
                                    <li class="tooltip-1">
                                        <span [class]="item.icon"></span>
                                        {{ item.label }}
                                    </li>
                                }
                            </ul>
                        </ng-template>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="status-icons">
                            <span
                                [class.icon-iec-star-solid]="row.isFavorite"
                                [attr.aria-label]="
                                    row.isFavorite ? 'Favorited' : null
                                "
                            ></span>
                            <span
                                [class.icon-iec-paperclip]="hasResponse(row)"
                                [attr.aria-label]="
                                    hasResponse(row)
                                        ? 'Response Attached'
                                        : null
                                "
                            ></span>
                            <span
                                [class.icon-iec-megaphone]="row.isFeatured"
                                [class.icon-iec-view]="
                                    row.isPublic && !row.isFeatured
                                "
                                [attr.aria-label]="
                                    row.isFeatured
                                        ? 'Featured Submission'
                                        : row.isPublic
                                          ? 'Public Display Allowed'
                                          : null
                                "
                            ></span>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Interactive">
                    <th mat-header-cell *matHeaderCellDef>Interactive</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{ interactiveName()(row.interactiveId) }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Date
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{
                                row.submissionTime | tzDate: "America/New_York"
                            }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{ submitterFor(row)?.name }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Location">
                    <th mat-header-cell *matHeaderCellDef>Location</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            @if (submitterFor(row); as submitter) {
                                {{ submitterLocation(submitter) }}
                            }
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Summary">
                    <th mat-header-cell *matHeaderCellDef>Summary</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            @if (row.isSpam) {
                                <span class="spam-indicator">Spam</span>
                            }
                            @if (row.state === "ARCHIVED") {
                                <span class="archived-indicator">Archived</span>
                            }
                            {{ row.shortDescription }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Type">
                    <th mat-header-cell *matHeaderCellDef>Type</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{
                                row.hasVideo
                                    ? "Video"
                                    : row.hasAudio
                                      ? "Voice"
                                      : "Text"
                            }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Segment">
                    <th mat-header-cell *matHeaderCellDef>Segment</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{ row.segmentLabel }}
                        </span>
                    </td>
                </ng-container>

                @for (category of categoryList() ?? []; track category.key) {
                    <ng-container [matColumnDef]="category.key">
                        <th mat-header-cell *matHeaderCellDef>
                            <span class="header-text">
                                {{ columnLabel()(category.key) }}
                            </span>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <span class="cell-text">
                                {{ row[category.key] }}
                            </span>
                        </td>
                    </ng-container>
                }

                <ng-container matColumnDef="Source">
                    <th mat-header-cell *matHeaderCellDef>Source</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="cell-text">
                            {{ row.profileId ? "Atlas App" : "Web" }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="footer">
                    <td
                        mat-footer-cell
                        *matFooterCellDef
                        [attr.colspan]="tableColumns().length"
                    >
                        <div class="table-footer">
                            <tools-paginator
                                [length]="(dataSource.count$ | async) ?? 0"
                                [pageSize]="dataSource.size"
                                [pageIndex]="
                                    (dataSource.page | async)?.index ?? 0
                                "
                                [pageSizeOptions]="pageSizeOptions"
                                (page)="onPageChange($event)"
                            />
                            <mat-form-field
                                appearance="outline"
                                class="page-size"
                            >
                                <mat-label>Rows per page</mat-label>
                                <mat-select
                                    [value]="dataSource.size"
                                    (selectionChange)="
                                        onPageSizeChange($event.value)
                                    "
                                >
                                    @for (size of pageSizeOptions; track size) {
                                        <mat-option [value]="size">
                                            {{ size }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <span class="body-2">
                                {{ dataSource.count$ | async }} Submissions
                            </span>
                        </div>
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="tableColumns(); sticky: true"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: tableColumns()"
                    [class.selected]="activeSubmission()?.id === row.id"
                    [class.dimmed]="row.isUsed || isSpamOrArchived(row)"
                    [attr.data-row-id]="row.id"
                ></tr>
                <tr mat-footer-row *matFooterRowDef="['footer']"></tr>
                <tr *matNoDataRow>
                    <td [attr.colspan]="tableColumns().length">
                        <div class="no-results">
                            <div class="no-results-content">
                                <h4>No Results</h4>
                                <p>
                                    Try changing your search query or filters,
                                    or check back later for new submissions.
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        @if (activeSubmission(); as submission) {
            <div class="right-panel">
                <div class="right-panel-header">
                    <span class="score" [ngClass]="scoreTier(submission.score)">
                        {{ submission.score ?? "&mdash;" }}
                    </span>
                    @if (isSpamOrArchived(submission)) {
                        <span class="submission-status">
                            {{ submission.isSpam ? "Spam" : "Archived" }}
                        </span>
                    } @else if (!isMarketer()) {
                        <mat-form-field
                            appearance="outline"
                            class="dropdown-queue"
                        >
                            <mat-select
                                placeholder="Queue"
                                [formControl]="queueControl"
                                (selectionChange)="onQueueChange($event.value)"
                            >
                                <mat-option [value]="null">&mdash;</mat-option>
                                @for (queue of queueOptions; track queue) {
                                    <mat-option [value]="queue">
                                        {{ queue }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <tools-toggle
                            [isChecked]="submission.isUsed"
                            [isControlled]="true"
                            (change)="onMarkUsedChange($event.checked)"
                        >
                            Mark Used
                        </tools-toggle>
                    }
                    <div class="right-panel-icons">
                        @if (!isSpamOrArchived(submission) && !isMarketer()) {
                            <button
                                type="button"
                                mat-icon-button
                                (click)="onDisplaySettingsClick()"
                                toolsTooltip="Public Display Settings"
                                toolsTooltipPosition="ABOVE"
                            >
                                <span
                                    [class.icon-iec-view]="submission.isPublic"
                                    [class.icon-iec-view-false]="
                                        !submission.isPublic
                                    "
                                ></span>
                            </button>
                            <button
                                type="button"
                                mat-icon-button
                                (click)="onFavoriteClick()"
                                [toolsTooltip]="
                                    submission.isFavorite
                                        ? 'Unfavorite'
                                        : 'Favorite'
                                "
                                toolsTooltipPosition="ABOVE"
                            >
                                <span
                                    [class.icon-iec-star-solid]="
                                        submission.isFavorite
                                    "
                                    [class.icon-star]="!submission.isFavorite"
                                ></span>
                            </button>
                        }
                        <button
                            type="button"
                            mat-icon-button
                            [matMenuTriggerFor]="submissionMenu"
                        >
                            <span class="icon-overflow-filled"></span>
                        </button>
                        <mat-menu #submissionMenu="matMenu">
                            @if (!isMarketer()) {
                                <button
                                    mat-menu-item
                                    (click)="onMoveSubmissionClick(submission)"
                                >
                                    Move Submission
                                </button>
                            }
                            @if (filters.submittedBy()) {
                                <button
                                    mat-menu-item
                                    class="stop-listener-filter"
                                    (click)="
                                        onStopViewingAllFromListenerClick()
                                    "
                                >
                                    Stop Viewing All From This Listener
                                </button>
                            } @else if (
                                submission.profileId || submission.deviceId
                            ) {
                                <button
                                    mat-menu-item
                                    (click)="
                                        onViewAllFromListenerClick(submission)
                                    "
                                >
                                    View all From Listener
                                </button>
                            }
                            @if (submission.isSpam && !isMarketer()) {
                                <button
                                    mat-menu-item
                                    (click)="onMarkAsNotSpamClick()"
                                >
                                    Mark as not spam
                                </button>
                            }
                            @if (!isMarketer()) {
                                <button
                                    mat-menu-item
                                    (click)="
                                        onDeleteSubmissionClick(submission)
                                    "
                                >
                                    Delete
                                </button>
                                @if (submission.state === "ARCHIVED") {
                                    <button
                                        mat-menu-item
                                        (click)="onRestoreClick()"
                                    >
                                        Restore
                                    </button>
                                } @else {
                                    <button
                                        mat-menu-item
                                        (click)="onArchiveClick()"
                                    >
                                        Archive
                                    </button>
                                }
                            }
                            @if (submission.hasVideo) {
                                <button
                                    mat-menu-item
                                    (click)="onDownloadVideoClick(submission)"
                                >
                                    Download Video
                                </button>
                            }
                            @if (submission.hasAudio && activeAudioUrl()) {
                                <button
                                    mat-menu-item
                                    (click)="onDownloadAudioClick(submission)"
                                >
                                    Download Audio
                                </button>
                            }
                            @if (submission.hasAudio && !isMarketer()) {
                                <button
                                    mat-menu-item
                                    (click)="onReplaceAudioClick()"
                                >
                                    Replace Audio
                                </button>
                            }
                        </mat-menu>
                        <input
                            #replaceAudioFileInput
                            type="file"
                            hidden
                            [attr.accept]="replaceAudioAcceptAttr"
                            (change)="onReplaceAudioFileSelected($event)"
                        />
                    </div>
                </div>
                <div class="submission-content">
                    <div class="submission-tabs">
                        @for (tab of submissionTabs(); track tab) {
                            <button
                                type="button"
                                class="submission-tab"
                                [class.active]="activeTab() === tab"
                                (click)="setActiveTab(tab)"
                            >
                                {{ tab }}
                            </button>
                        }
                        @if (
                            !isMarketer() &&
                            !isInEditMode() &&
                            !(
                                activeTab() === "notes" &&
                                submission.notes === null
                            ) &&
                            !(
                                activeTab() === "response" &&
                                (badges() === null || !hasResponse(submission))
                            )
                        ) {
                            <button
                                type="button"
                                class="tab-edit-btn"
                                (click)="toggleEditMode()"
                            >
                                <span class="icon-edit"></span>
                                Edit
                            </button>
                        }
                    </div>
                    @if (activeTab() === "submission") {
                        @if (isInEditMode()) {
                            <div class="submission-edit">
                                <tools-textarea
                                    [maxLength]="editCleanedTextMaxLength()"
                                    [formControl]="editCleanedTextControl"
                                    [singleLine]="true"
                                ></tools-textarea>
                                <app-tag-list
                                    [ngModel]="editTagOptions()"
                                    (removed)="removeEditTag($event)"
                                />
                                <div class="edit-actions">
                                    <tools-button
                                        [variant]="ButtonVariant.OUTLINE"
                                        (onClick)="toggleEditMode()"
                                    >
                                        Cancel
                                    </tools-button>
                                    <tools-button
                                        [isDisabled]="
                                            editCleanedTextControl.invalid
                                        "
                                        (onClick)="onUpdateSubmissionClick()"
                                    >
                                        Update Submission
                                    </tools-button>
                                </div>
                            </div>
                        } @else {
                            <div class="tab-submission">
                                <p
                                    class="submission-text"
                                    [class.collapsed]="!isTranscriptExpanded()"
                                    #submissionText
                                >
                                    {{ submission.cleanedText }}
                                </p>
                                @if (
                                    isTranscriptClamped() ||
                                    isTranscriptExpanded()
                                ) {
                                    <button
                                        class="show-full-transcript"
                                        (click)="toggleTranscript()"
                                    >
                                        {{
                                            isTranscriptExpanded()
                                                ? "Show Less"
                                                : "Show Full Transcript"
                                        }}
                                    </button>
                                }
                            </div>
                        }
                    } @else if (activeTab() === "notes") {
                        @if (isInEditMode()) {
                            <div class="notes-edit">
                                <tools-textarea
                                    placeholder="Add talking points or context for the host."
                                    [maxLength]="notesMaxLength"
                                    [formControl]="editNotesControl"
                                    [singleLine]="true"
                                ></tools-textarea>
                                <div class="edit-actions">
                                    <tools-button
                                        [variant]="ButtonVariant.OUTLINE"
                                        (onClick)="toggleEditMode()"
                                    >
                                        Cancel
                                    </tools-button>
                                    <tools-button
                                        [isDisabled]="editNotesControl.invalid"
                                        (onClick)="onUpdateNotesClick()"
                                    >
                                        {{
                                            submission.notes === null
                                                ? "Add Notes"
                                                : "Update Notes"
                                        }}
                                    </tools-button>
                                </div>
                            </div>
                        } @else if (submission.notes === null) {
                            <div class="notes-placeholder">
                                <h4>No Notes Yet</h4>
                                <p>
                                    Add context for this submission, like
                                    talking points, reminders, or why it may be
                                    useful on air.
                                </p>
                                <tools-button
                                    [variant]="ButtonVariant.OUTLINE"
                                    (onClick)="toggleEditMode()"
                                >
                                    Add Notes
                                </tools-button>
                            </div>
                        } @else {
                            <p class="subtitle-2">
                                {{ submission.notes }}
                            </p>
                        }
                    } @else if (
                        activeTab() === "response" && badges() !== null
                    ) {
                        @if (hasResponse(submission)) {
                            <div class="response-details">
                                @if (
                                    (!submission.responseHideBadgeImage &&
                                        getResponseBadge(submission)
                                            ?.imageUrl) ||
                                    responseText(submission) !== null
                                ) {
                                    <div class="response-message">
                                        @if (
                                            !submission.responseHideBadgeImage &&
                                                getResponseBadge(submission);
                                            as badge
                                        ) {
                                            @if (badge.imageUrl) {
                                                <img
                                                    [src]="badge.imageUrl"
                                                    [alt]="
                                                        badge.name ?? 'Badge'
                                                    "
                                                />
                                            }
                                        }
                                        @if (
                                            responseText(submission) !== null
                                        ) {
                                            <p>
                                                &ldquo;{{
                                                    responseText(submission)
                                                }}&rdquo;
                                            </p>
                                        }
                                    </div>
                                }
                                @if (submission.responseLink) {
                                    <div class="response-section">
                                        <p class="body-1">Link</p>
                                        <p>
                                            {{ submission.responseLink }}
                                        </p>
                                    </div>
                                }
                                @if (
                                    submission.responseAudioPath &&
                                        activeResponseAudioUrl();
                                    as audioUrl
                                ) {
                                    <div class="response-section">
                                        <p class="body-1">Voice Response</p>
                                        <audio
                                            controls
                                            controlsList="nodownload noplaybackrate"
                                            [src]="audioUrl"
                                        ></audio>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="response-placeholder">
                                @if (isMarketer()) {
                                    <h4>No Response Posted Yet</h4>
                                    <p>
                                        This submission hasn't received a
                                        producer response.
                                    </p>
                                } @else {
                                    <h4>No Response Yet</h4>
                                    <p>
                                        Compose a response for this listener
                                        with a message, badge, link, or voice
                                        response.
                                    </p>
                                    <tools-button
                                        [variant]="ButtonVariant.OUTLINE"
                                        (onClick)="onOpenResponseModal()"
                                    >
                                        Compose Response
                                    </tools-button>
                                }
                            </div>
                        }
                    }
                </div>
                <div class="submission-metadata">
                    @if (activeTab() !== "submission" || !isInEditMode()) {
                        <div
                            class="submission-tags"
                            #tagsOrigin="cdkOverlayOrigin"
                            cdkOverlayOrigin
                            (mouseenter)="showTagsOverlay()"
                            (mouseleave)="hideTagsOverlay()"
                        >
                            @if (
                                submissionTags(submission)
                                    | splitter: maxVisibleSubmissionTags;
                                as tagSplit
                            ) {
                                @for (
                                    tag of tagSplit.visible;
                                    track $index + "-" + tag
                                ) {
                                    <app-tag
                                        class="submission-tag"
                                        [option]="{ value: tag, label: tag }"
                                    />
                                }
                                @if (tagSplit.hiddenCount > 0) {
                                    <app-tag
                                        [option]="{
                                            value: null,
                                            label: '+' + tagSplit.hiddenCount
                                        }"
                                    />
                                }
                            }
                        </div>
                        <ng-template
                            cdk-connected-overlay
                            [cdkConnectedOverlayOrigin]="tagsOrigin"
                            [cdkConnectedOverlayOpen]="isTagsOverlayOpen"
                            [cdkConnectedOverlayPositions]="overlayPositions"
                            [cdkConnectedOverlayPush]="true"
                        >
                            <div class="tags-overlay-panel">
                                @for (
                                    tag of submissionTags(submission);
                                    track $index + "-" + tag
                                ) {
                                    <p class="tooltip-1">{{ tag }}</p>
                                }
                            </div>
                        </ng-template>
                    }
                    <div class="submission-type">
                        @if (submission.hasAudio) {
                            <div class="intensity">
                                <span class="caption-3">
                                    {{ audioEnergyLabel() ?? "Intensity" }}:
                                    {{
                                        submission.audioEnergy !== null
                                            ? submission.audioEnergy * 20
                                            : "&mdash;"
                                    }}%
                                </span>
                                <mat-progress-bar
                                    mode="determinate"
                                    [value]="(submission.audioEnergy ?? 0) * 20"
                                    class="intensity-bar"
                                />
                            </div>
                        } @else {
                            <div class="text-submission">
                                <span class="icon-iec-text-msg"></span>
                                <span class="caption-3">Text Submission</span>
                            </div>
                        }
                        <p class="caption-3">
                            Submitted via
                            {{ submission.profileId ? "Atlas App" : "Web" }}
                        </p>
                    </div>
                    @if (submission.hasAudio && activeAudioUrl(); as audioUrl) {
                        <audio
                            controls
                            controlsList="nodownload noplaybackrate"
                            [src]="audioUrl"
                        ></audio>
                    }
                </div>
                @if (segmentOptions().length > 0) {
                    @let isUnconfiguredSegment =
                        isUnconfiguredSegmentOption(submission);
                    @let segmentSelectOptions =
                        isUnconfiguredSegment
                            ? [unconfiguredSegmentOption(submission)].concat(
                                  segmentOptions()
                              )
                            : segmentOptions();
                    <div class="submission-segment">
                        <mat-form-field
                            appearance="outline"
                            class="dropdown-segment"
                        >
                            <mat-label>Choose a segment</mat-label>
                            <mat-select
                                [value]="submission.segmentId"
                                [disabled]="isMarketer()"
                                (selectionChange)="onSegmentChange($event)"
                            >
                                @for (
                                    segment of segmentSelectOptions;
                                    track segment.id
                                ) {
                                    <mat-option
                                        [value]="segment.id"
                                        [disabled]="
                                            isUnconfiguredSegment && $first
                                        "
                                    >
                                        {{ segment.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (isUnconfiguredSegment) {
                            <p class="segment-warning caption-3">
                                Current selection is not in the configured
                                option list.
                            </p>
                        }
                    </div>
                }
                @if (submitterFor(submission); as submitter) {
                    <div class="submitter-info">
                        @if (submitter.name) {
                            <div>
                                <span class="icon-iec-profile"></span>
                                <span class="caption-3">
                                    {{ submitter.name }}
                                </span>
                            </div>
                        }
                        @if (submitterLocation(submitter); as location) {
                            <div>
                                <span class="icon-location"></span>
                                <span class="caption-3">{{ location }}</span>
                            </div>
                        }
                        @if (submitter.phoneNumber) {
                            <div>
                                <span class="icon-iec-phone"></span>
                                <span class="caption-3">
                                    {{ submitter.phoneNumber }}
                                </span>
                            </div>
                        }
                        @if (submitter.email) {
                            <div>
                                <span class="icon-iec-envelope"></span>
                                <span class="caption-3">
                                    {{ submitter.email }}
                                </span>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
</div>
